import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import cookies from '@/assets/scripts/util/cookies';
Vue.use(Vuex);

const modulesFiles = require.context('./modules', true, /\.js$/);

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
    const value = modulesFiles(modulePath);

    modules[moduleName] = value.default;

    return modules;
  }, {});


export default new Vuex.Store({
    state: {
        isLogin: cookies.getItem('_login'),
        pwd: '123457',
        keekAlives:[],
    },
    mutations: {
        changeLogin(state, status) {
            cookies.setItem('_login', true);
            state.isLogin = status;
        },
        SET_KEEP_ALIVE:function(state, keekAlives){
            return state.keekAlives = keekAlives;
        }
    },
    actions: {
        loginAction({ commit }) {
            commit('changeLogin', true);
        }
    },
    modules,
    getters
});